<template>
<div container--fluid>
    <v-layout>
        <PlanPaymentModule :plan-id="plan_id"></PlanPaymentModule>
    </v-layout>
</div>
</template>

<script>
import PlanPaymentModule from '@modules/plans/payment.vue';

export default {
    name: 'PlanPayment',
    components: {
        PlanPaymentModule,
    },
    props: {
        'plan_id': {
            type: [Number, String],
            required: true
        }
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
